<iframe #iframe [src]="params.source | urlSanitizer" [class]="params.cssClass" [attr.name]="name"></iframe>